import React from "react";
import { ImageIcon } from "lucide-react";
type ImagePlaceholderProps = {
  caption: string;
  className?: string;
};
export function ImagePlaceholder({
  caption,
  className = ""
}: ImagePlaceholderProps) {
  return <figure className={className} data-id="element-100" data-mp="8a1zaay2ddrv">
      <div role="img" aria-label={`Image placeholder: ${caption}`} className="flex h-full w-full flex-col items-center justify-center gap-2 rounded-3xl bg-paper text-espresso/70" data-id="element-101" data-mp="890idpud9x28">
        <ImageIcon className="h-8 w-8" strokeWidth={1.25} data-id="element-102" data-mp="3vdgi4hhg4kfs" />
        <span className="text-xs font-medium uppercase tracking-wide" data-id="element-103" data-mp="3qfwyf21zbfgg">Image</span>
      </div>
      <figcaption className="mt-3 text-sm text-espresso/70" data-id="element-104" data-mp="3liepvcrvj28z">{caption}</figcaption>
    </figure>;
}